var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundHoldingsZeroState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_26799)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.049,
    cy: 41.5158,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.318,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.308,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.566 100.347C167.566 137.155 137.462 167.008 100.308 167.008C63.1536 167.008 33.0493 137.155 33.0493 100.347C33.0493 63.5387 63.1536 33.6851 100.308 33.6851C137.462 33.6851 167.566 63.5387 167.566 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.61489,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.293,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5449,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3154,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7998,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4331,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.4995,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5478,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3667,
    cy: 22.4228,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8095,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.436,
    cy: 18.8427,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51221 117.65C7.5667 117.65 8.42153 116.795 8.42153 115.741C8.42153 114.686 7.5667 113.832 6.51221 113.832",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5317 22.4226C75.5862 22.4226 76.4411 21.5678 76.4411 20.5133C76.4411 19.4588 75.5862 18.604 74.5317 18.604",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.779 15.7399 118.924 16.5948 118.924 17.6493C118.924 18.7038 119.779 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3306 166.934H16.2972M26.3211 155.836V157.388M38.0157 166.934H39.5671M26.3211 176.481V178.271M26.3211 180.658V186.982M21.9058 166.934C24.8892 166.934 26.4405 162.638 26.4405 162.638C26.4405 162.638 26.9178 166.934 30.7365 166.934C29.0181 166.934 26.5598 168.486 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.128C24.3635 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0596L172.742 30.0596M162.599 45.8115L162.718 39.6062M151.024 30.0596L149.472 30.0596M162.599 20.7516L162.599 8.57973M167.134 30.0596C164.15 30.0596 162.599 34.3556 162.599 34.3556C162.599 34.3556 162.122 30.0596 158.303 30.0596C160.021 30.0596 162.48 28.5083 162.718 25.4056C162.718 25.4056 162.996 27.9458 163.912 28.8663C164.676 29.6348 167.134 30.0596 167.134 30.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.646 84.173L75.6692 72.1627V148.943H48.646V84.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6692 72.1627L48.646 84.173V148.943H75.6692M134.863 141.222V148.943H75.6692M134.863 84.173V49H75.6692V148.943",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.646 93.6094H71.8087",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.646 105.62H71.8087",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.646 119.346H71.8087",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.646 133.072H71.8087",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.8164,
    y: 54.147,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8164,
    y: 55.147,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.8164,
    y: 72.1626,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8164,
    y: 73.1626,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.8164,
    y: 90.1782,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8164,
    y: 91.1782,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.8164,
    y: 108.193,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8164,
    y: 109.193,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.6797,
    y: 127.067,
    width: 35.173,
    height: 22.3049,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.6797,
    y: 128.067,
    width: 33.173,
    height: 20.3049,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1167,
    y: 54.147,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1167,
    y: 55.147,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1167,
    y: 72.1626,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1167,
    y: 73.1626,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1167,
    y: 90.1782,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1167,
    y: 91.1782,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1167,
    y: 108.193,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1167,
    y: 109.193,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.416,
    y: 54.147,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.416,
    y: 55.147,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.416,
    y: 72.1626,
    width: 12.8682,
    height: 12.8682,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.416,
    y: 73.1626,
    width: 10.8682,
    height: 10.8682,
    rx: 3,
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.039 86.7466C131.895 86.7466 117.74 91.036 116.024 92.7517C114.308 94.4675 115.595 112.226 115.595 116.343C115.595 120.461 117.883 124.636 119.027 126.209C122.458 129.355 129.321 135.646 131.466 137.361C133.611 139.077 136.184 138.648 137.471 137.361C138.758 136.075 144.554 132.622 147.766 128.354C151.191 123.801 153.485 117.916 153.771 115.057C154.057 112.197 154.2 94.4675 152.913 92.7517C151.626 91.036 136.184 86.7466 134.039 86.7466Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.4337,
    height: 29.4337,
    transform: "translate(120.024 95.1089)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.741 122.618C131.323 122.618 128.111 121.287 125.694 118.873C123.276 116.459 121.948 113.244 121.948 109.826C121.948 106.408 123.28 103.196 125.694 100.779C128.107 98.3614 131.323 97.0332 134.741 97.0332C138.159 97.0332 141.371 98.3651 143.788 100.779C146.205 103.192 147.533 106.408 147.533 109.826C147.533 113.244 146.202 116.456 143.788 118.873C141.374 121.29 138.159 122.618 134.741 122.618ZM134.741 97.1804C131.363 97.1804 128.188 98.4975 125.8 100.885C123.413 103.273 122.095 106.448 122.095 109.826C122.095 113.203 123.413 116.378 125.8 118.766C128.188 121.154 131.363 122.471 134.741 122.471C138.118 122.471 141.294 121.154 143.681 118.766C146.069 116.378 147.386 113.203 147.386 109.826C147.386 106.448 146.069 103.273 143.681 100.885C141.294 98.4975 138.118 97.1804 134.741 97.1804Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.741 119.252C132.224 119.252 129.859 118.273 128.078 116.493C126.297 114.712 125.318 112.346 125.318 109.83C125.318 107.313 126.297 104.947 128.078 103.167C129.859 101.386 132.224 100.407 134.741 100.407C137.257 100.407 139.623 101.386 141.404 103.167C143.185 104.947 144.163 107.313 144.163 109.83C144.163 112.346 143.185 114.712 141.404 116.493C139.623 118.273 137.257 119.252 134.741 119.252ZM134.741 100.547C132.261 100.547 129.932 101.511 128.181 103.266C126.429 105.017 125.462 107.346 125.462 109.826C125.462 112.306 126.426 114.635 128.181 116.386C129.932 118.137 132.261 119.105 134.741 119.105C137.221 119.105 139.55 118.141 141.301 116.386C143.052 114.635 144.02 112.306 144.02 109.826C144.02 107.346 143.056 105.017 141.301 103.266C139.55 101.515 137.221 100.547 134.741 100.547Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74 113.479C132.724 113.479 131.087 111.842 131.087 109.826C131.087 107.81 132.724 106.172 134.74 106.172C136.757 106.172 138.394 107.81 138.394 109.826C138.394 111.842 136.757 113.479 134.74 113.479ZM134.74 106.32C132.809 106.32 131.234 107.894 131.234 109.826C131.234 111.757 132.809 113.332 134.74 113.332C136.672 113.332 138.247 111.757 138.247 109.826C138.247 107.894 136.672 106.32 134.74 106.32Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M140.392 112.118C143.68 112.118 146.345 109.453 146.345 106.165C146.345 102.877 143.68 100.212 140.392 100.212C137.105 100.212 134.439 102.877 134.439 106.165C134.439 109.453 137.105 112.118 140.392 112.118Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.741 122.618C131.323 122.618 128.111 121.287 125.694 118.873C123.276 116.459 121.948 113.244 121.948 109.826C121.948 106.408 123.28 103.196 125.694 100.779C128.107 98.3614 131.323 97.0332 134.741 97.0332C138.159 97.0332 141.371 98.3651 143.788 100.779C146.205 103.192 147.533 106.408 147.533 109.826C147.533 113.244 146.202 116.456 143.788 118.873C141.374 121.29 138.159 122.618 134.741 122.618ZM134.741 97.1804C131.363 97.1804 128.188 98.4975 125.8 100.885C123.413 103.273 122.095 106.448 122.095 109.826C122.095 113.203 123.413 116.378 125.8 118.766C128.188 121.154 131.363 122.471 134.741 122.471C138.118 122.471 141.294 121.154 143.681 118.766C146.069 116.378 147.386 113.203 147.386 109.826C147.386 106.448 146.069 103.273 143.681 100.885C141.294 98.4975 138.118 97.1804 134.741 97.1804Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.277 110.569C123.512 110.569 122.772 110.672 122.066 110.863C122.125 111.573 122.239 112.265 122.408 112.938C122.997 112.754 123.626 112.655 124.277 112.655C127.743 112.655 130.554 115.466 130.554 118.932C130.554 119.888 130.34 120.797 129.954 121.61C130.598 121.871 131.271 122.085 131.963 122.239C132.401 121.224 132.644 120.109 132.644 118.935C132.64 114.314 128.895 110.569 124.277 110.569Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.06 101.169C143.174 100.216 142.147 99.3991 141.007 98.7552C141.706 99.469 142.14 100.444 142.14 101.522C142.14 103.704 140.374 105.47 138.192 105.47C136.01 105.47 134.244 103.704 134.244 101.522C134.244 99.3476 135.999 97.5852 138.17 97.5742C137.081 97.2688 135.929 97.1069 134.745 97.1069C134.598 97.1069 134.45 97.1106 134.303 97.1143C133.085 98.1923 132.316 99.767 132.316 101.522C132.316 104.771 134.947 107.401 138.196 107.401C141.445 107.401 144.075 104.771 144.075 101.522C144.071 101.404 144.064 101.287 144.06 101.169Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.395 107.327C124.108 107.327 123.84 107.154 123.726 106.875C123.652 106.694 123.656 106.499 123.733 106.323C123.81 106.146 123.95 106.01 124.127 105.937C124.495 105.789 124.918 105.97 125.065 106.338C125.139 106.518 125.135 106.713 125.058 106.889C124.98 107.066 124.841 107.202 124.664 107.276C124.576 107.309 124.484 107.327 124.395 107.327ZM124.392 106.032C124.322 106.032 124.248 106.047 124.178 106.073C124.035 106.132 123.924 106.238 123.866 106.382C123.807 106.522 123.803 106.68 123.862 106.82C123.98 107.114 124.314 107.257 124.609 107.14C124.752 107.081 124.863 106.974 124.922 106.831C124.98 106.691 124.984 106.533 124.925 106.393C124.837 106.168 124.62 106.032 124.392 106.032Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.091 113.784C144.804 113.784 144.535 113.611 144.421 113.332C144.348 113.152 144.351 112.957 144.428 112.78C144.506 112.603 144.646 112.467 144.822 112.394C145.19 112.246 145.613 112.423 145.76 112.795C145.908 113.163 145.731 113.586 145.359 113.733C145.271 113.766 145.179 113.784 145.091 113.784ZM145.087 112.489C145.017 112.489 144.944 112.504 144.874 112.53C144.73 112.589 144.62 112.695 144.561 112.839C144.502 112.979 144.498 113.137 144.557 113.277C144.675 113.571 145.01 113.714 145.304 113.597C145.598 113.479 145.742 113.144 145.624 112.85C145.532 112.625 145.315 112.489 145.087 112.489Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.551 105.882C130.518 105.882 130.485 105.882 130.448 105.878C130.19 105.852 129.962 105.727 129.8 105.525C129.638 105.322 129.565 105.072 129.59 104.818C129.616 104.565 129.741 104.333 129.944 104.171C130.356 103.836 130.967 103.899 131.301 104.311C131.463 104.509 131.537 104.763 131.511 105.017C131.485 105.271 131.36 105.503 131.158 105.665C130.985 105.804 130.772 105.882 130.551 105.882ZM130.547 104.097C130.359 104.097 130.179 104.16 130.032 104.281C129.863 104.417 129.756 104.616 129.734 104.833C129.712 105.05 129.774 105.264 129.911 105.433C130.047 105.602 130.245 105.709 130.462 105.731C130.68 105.753 130.893 105.69 131.062 105.554C131.231 105.418 131.338 105.219 131.36 105.002C131.382 104.785 131.32 104.572 131.184 104.403C131.047 104.233 130.849 104.127 130.632 104.105C130.606 104.101 130.577 104.097 130.547 104.097Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.678 115.896C138.399 115.896 138.119 115.775 137.928 115.539C137.766 115.341 137.692 115.087 137.718 114.833C137.744 114.579 137.869 114.347 138.071 114.186C138.483 113.851 139.094 113.913 139.429 114.325C139.764 114.737 139.701 115.348 139.289 115.683C139.105 115.826 138.892 115.896 138.678 115.896ZM138.675 114.116C138.494 114.116 138.31 114.174 138.159 114.3C137.81 114.583 137.755 115.098 138.038 115.451C138.321 115.804 138.836 115.856 139.19 115.573C139.539 115.289 139.594 114.774 139.311 114.421C139.149 114.219 138.914 114.116 138.675 114.116Z",
    fill: "#194590"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_26799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundHoldingsZeroState);
export default __webpack_public_path__ + "static/media/fund-holdings-zero-state.45a8e6c58f5816d5069a8cd10dcb3555.svg";
export { ForwardRef as ReactComponent };